import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'ra-ui-materialui';
import CheckIcon from '@material-ui/icons/Check';


class ApproveButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
    };
  }

  handleClick = async () => {
    if (this.state.isSubmitting) {
      return;
    }
    this.setState({ isSubmitting: true });
    const { recordType, record, approve } = this.props;
    await approve(recordType, record.id);
    this.setState({ isSubmitting: false });
  };

  render() {
    const {
      recordType,
      record,
      approve,
      ...rest
    } = this.props;
    return (
      <Button
        label={record && record.approvedAt ? 'Approved' : 'Approve'}
        onClick={this.handleClick}
        disabled={!!(this.state.isSubmitting ||
          (record && record.approvedAt) ||
          (record && record.accountRestrictions && record.accountRestrictions.length > 0))
        }
        {...rest}
      >
        <CheckIcon />
      </Button>
    );
  }
}

ApproveButton.propTypes = {
  recordType: PropTypes.string.isRequired,
  record: PropTypes.shape({
    id: PropTypes.string,
  }),

  approve: PropTypes.func.isRequired,
};

ApproveButton.defaultProps = {
  record: null,
};


const approveAction = (resource, id) => ({
  type: 'APPROVE',
  payload: {
    id,
    resource,
  },
  meta: {
    fetch: 'APPROVE_ONE',
    resource,
    refresh: true, // refresh this object after approval
  },
});


export default connect(null, {
  approve: approveAction,
})(ApproveButton);



// WEBPACK FOOTER //
// ./src/components/ApproveButton.js